/*
*
* File JS componente Hero HP
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './hero-full-slider.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const initSwiper = () => {
    let sliderHP = document.querySelector('.hero-full-slider .swiper-container');

    if (!sliderHP) return;

    let pagination = sliderHP.querySelector('.hero-full-slider__pagination');
    let navPrev = sliderHP.querySelector('.hero-full-slider__wrap-nav .swiper-button-prev');
    let navNext = sliderHP.querySelector('.hero-full-slider__wrap-nav .swiper-button-next');

    Swiper.use([Navigation, Pagination]);

    const args = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        pagination: {
            el: pagination,
            type: 'bullets',
        },
        navigation: 
        {
            nextEl: navNext,
            prevEl: navPrev,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };

    new Swiper(sliderHP, args);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const heroFullSlider = () => {

    initSwiper();

}

export default heroFullSlider;

//--------------------------------------------------------------------//